import { useEffect, useState } from "react";
import { Loading } from "components";
import { EndUserState } from "helpers";
import { UserTableDataOptions } from "./components/UserTableDataOptions";
import { t } from "i18next";

interface UserTableDataProps {
  endUsers: EndUserState[];
  isLoading: boolean;
  onFlag: (endUsers: EndUserState) => void;
  onEdit: (endUsers: EndUserState) => void;
}

export const UserTableData = ({ endUsers, isLoading, onFlag, onEdit }: UserTableDataProps) => {
  return (
    <>
      {endUsers.length > 0 ? (
        endUsers.map((endUser, index) => (
          <tr key={index} className="h-[100px] border-y text-center">
            <td className="w-full text-center text-sm">{endUser.full_name}</td>
            <td className="w-full text-center text-sm">{endUser.company_name}</td>
            <td className="w-full text-center text-sm">
              {endUser.phone_number} {t("common.and")} {endUser.email}
            </td>
            <td className="w-full text-center text-sm">{endUser.last_signin}</td>
            <td className="w-full text-center text-sm">
              {endUser.confirmation_status ? t("common.active") : t("common.inactive")}
            </td>
            <td className="w-full text-center text-sm">
              {(() => {
                const activeDevices = endUser.devices?.filter((device) => device.is_active).length || 0;
                return endUser.logged_in
                  ? `${t("userManagement.loggedIn")} (${activeDevices} ${
                      activeDevices === 1 ? t("userManagement.device") : t("userManagement.devices")
                    })`
                  : t("userManagement.loggedOut");
              })()}
            </td>
            <td className="w-full text-center text-sm">{endUser.credits ?? t("common.notAvailable")}</td>
            <td className="sticky right-0 z-10 w-[200px] min-w-[200px] bg-white text-center text-sm">
              <UserTableDataOptions endUsers={endUser} onFlag={onFlag} onEdit={onEdit} />
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td className="text-center text-gray-500">{t("userManagement.noUsersFound")}</td>
        </tr>
      )}

      {isLoading && (
        <tr>
          <td colSpan={3}>
            <Loading absolute className="inset-0" />
          </td>
        </tr>
      )}
    </>
  );
};
